import type { FC } from 'react'

import { Tooltip } from 'antd'
import cn from 'classnames'

import styles from './mcm-tooltip.module.css'

import type { TooltipProps } from 'antd'

type FormTooltipType = {
  theme?: 'dark' | 'light'
  content?: string | JSX.Element
  className?: string
} & TooltipProps

const McmTooltip: FC<FormTooltipType> = ({
  theme,
  className,
  content,
  ...props
}) => (
  <Tooltip title={content} trigger='click' {...props}>
    <span
      className={cn(styles['icon-info'], className, 'material-symbols-sharp', {
        [styles['icon-info-light']]: theme === 'light',
        [styles['icon-info-dark']]: theme === 'dark'
      })}
    >
      info
    </span>
  </Tooltip>
)

export default McmTooltip
